import { Component } from '@angular/core';

@Component({
    selector: 'app-access-denied',
    imports: [],
    templateUrl: './access-denied.component.html'
})
export class AccessDeniedComponent { }
